import { GroupDTO } from '@/model';
import { apiGenericGet, apiGenericPost } from '@/service';
import { getApiUrl } from '@/util';
import { SaveResponse } from '@/type';

const BASE_URL = '/api/v1/group/';

export const listUserGroupsAPI = (): Promise<GroupDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'getUserGroups'));

export const listUserGroupsToPreloadAPI = (): Promise<GroupDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'getUserGroupsToPreload'));

export const listAllGroupsAPI = (): Promise<GroupDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'list'));

export const saveGroupAPI = (request: GroupDTO): SaveResponse =>
  apiGenericPost(getApiUrl(BASE_URL, 'save'), request);

export const loadGroupAPI = (id: number): Promise<GroupDTO> =>
  apiGenericGet(getApiUrl(BASE_URL, `load/${id}`));
